export function toMinutesAfterMidnight(time: string) {
    const d = new Date(time)
    return d.getHours() * 60 + d.getMinutes();
}